import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';

const FORM_URL = 'https://forms.gle/7hxrh5weVecA8eYPA';

const Contact = () => {
  return (
    <>
      <SEO
        title="Contact"
        path="/contact"
        description="Request API access or get in touch with InjectAI Labs. We'll review your request and schedule a quick call."
      />
      <section id="contact" className="py-24 pt-36 bg-dark-light min-h-screen">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary/10 border border-primary/20 rounded-full text-xs text-primary font-medium mb-6 uppercase tracking-widest">
          Get Started
        </div>
        <h2 className="text-4xl md:text-5xl font-bold mb-5 leading-tight">
          Ready to integrate AI?
        </h2>
        <p className="text-gray-400 text-lg mb-10 max-w-xl mx-auto leading-relaxed">
          Request your API endpoint and secret key. We'll review your request and schedule a quick call.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
          <a
            href={FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-primary hover:bg-blue-600 rounded-xl font-semibold text-base transition-all transform hover:scale-105"
          >
            Request Access →
          </a>
          <a
            href="mailto:injectailabs.space@gmail.com"
            className="px-8 py-4 border border-gray-700 hover:border-primary hover:bg-primary/5 rounded-xl font-semibold text-base text-gray-300 transition-all"
          >
            Email Us
          </a>
        </div>

        <p className="text-gray-600 text-sm">
          <a href="mailto:injectailabs.space@gmail.com" className="text-gray-500 hover:text-secondary transition-colors">
            injectailabs.space@gmail.com
          </a>
        </p>
      </div>
    </section>
    </>
  );
};

export default Contact;
